import { render, staticRenderFns } from "./GapForm.vue?vue&type=template&id=142f2d20&"
import script from "./GapForm.vue?vue&type=script&lang=js&"
export * from "./GapForm.vue?vue&type=script&lang=js&"
import style0 from "./GapForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports